var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { bindable, BoundViewFactory, templateController, ViewSlot } from 'aurelia-templating';
import { autoinject } from "aurelia-dependency-injection";
var AnimatableJsIfCustomAttribute = /** @class */ (function () {
    function AnimatableJsIfCustomAttribute(viewFactory, viewSlot) {
        this.viewFactory = viewFactory;
        this.viewSlot = viewSlot;
        this.animation = null;
        this.selector = null;
        this.value = true;
        this.bindingContext = null;
        this.overrideContext = null;
        this.view = null;
        this.showing = false;
    }
    AnimatableJsIfCustomAttribute.prototype.bind = function (bindingContext, overrideContext) {
        this.bindingContext = bindingContext;
        this.overrideContext = overrideContext;
        this.valueChanged(this.value);
    };
    ;
    AnimatableJsIfCustomAttribute.prototype.valueChanged = function (newValue) {
        var _this = this;
        var viewOrPromise = void 0;
        if (!newValue) {
            if (this.view !== null && this.showing) {
                if (this.animation) {
                    this.funcOut = function () {
                        if (_this.view) {
                            _this.funcOut = null;
                            viewOrPromise = _this.viewSlot.remove(_this.view, false, true);
                            viewOrPromise.unbind();
                        }
                    };
                    this.animation.cancelOn($(this.view.firstChild).find(this.selector));
                    this.animation.off($(this.view.firstChild).find(this.selector)).then(function (x) {
                        _this.funcOut();
                    });
                }
            }
            this.showing = false;
        }
        else {
            if (this.funcOut) {
                this.funcOut = null;
                this.animation.cancelOff($(this.view.firstChild).find(this.selector));
                if (this.viewSlot.children.length > 0) {
                    viewOrPromise = this.viewSlot.remove(this.view, false, true);
                    viewOrPromise.unbind();
                }
            }
            if (this.view === null) {
                this.view = this.viewFactory.create();
            }
            if (!this.view.isBound) {
                this.view.bind(this.bindingContext, this.overrideContext);
            }
            if (!this.showing) {
                this.showing = true;
                this.viewSlot.add(this.view);
                if (this.animation) {
                    this.animation.on($(this.view.firstChild).find(this.selector));
                }
            }
        }
    };
    AnimatableJsIfCustomAttribute.prototype.unbind = function () {
        if (this.view === null) {
            return;
        }
        this.view.unbind();
        if (this.funcOut && !this.value) {
            this.view.firstChild.removeEventListener("animationend", this.funcOut, false);
            if (this.view.firstChild.classList.contains("au-leave-active")) {
                (this.view.firstChild).classList.remove("au-leave-active");
            }
            this.funcOut = null;
            if (this.viewSlot.children.length > 0) {
                var viewOrPromise = this.viewSlot.remove(this.view, false, true);
                viewOrPromise.unbind();
            }
        }
        if (!this.viewFactory.isCaching) {
            return;
        }
        if (this.showing) {
            this.showing = false;
            this.viewSlot.remove(this.view, true, true);
        }
        this.view.returnToCache();
        this.view = null;
        this.bindingContext = null;
        this.overrideContext = null;
    };
    ;
    __decorate([
        bindable,
        __metadata("design:type", Object)
    ], AnimatableJsIfCustomAttribute.prototype, "animation", void 0);
    __decorate([
        bindable,
        __metadata("design:type", String)
    ], AnimatableJsIfCustomAttribute.prototype, "selector", void 0);
    __decorate([
        bindable,
        __metadata("design:type", Boolean)
    ], AnimatableJsIfCustomAttribute.prototype, "value", void 0);
    AnimatableJsIfCustomAttribute = __decorate([
        autoinject(),
        templateController(),
        __metadata("design:paramtypes", [BoundViewFactory, ViewSlot])
    ], AnimatableJsIfCustomAttribute);
    return AnimatableJsIfCustomAttribute;
}());
export { AnimatableJsIfCustomAttribute };
